











































	import { BaseTLTableComponent, AxiosResponse, Component, EmployeeService, EmployeeFilter, Prop } from "../../../Infrastructure/CorBase/CoreBase";

	@Component
	export default class EmploymentList extends BaseTLTableComponent {
		selectedEmployeeId: number = 0;
		EmployeeService: EmployeeService = new EmployeeService();
		@Prop({ type: Boolean, required: false, default: false }) isShowModal?: boolean; //zobrazení v modálním dialogu
		@Prop({ type: Boolean, required: false, default: false }) isShowModalMulti?: boolean; //zobrazení v modálním dialogu, multiSelect

		created() {
			
			super.initializeRights('COR_Employment_Create', 'COR_EmploymentD_Delete', 'COR_Employment_Read', 'COR_Employment_Update');
			super.created();
		
		};

		names = [ 'idPersonNavigationLastname', 'idPersonNavigationFirstname' ];
	

		setFields() {

			if (this.isShowModalMulti) {
				this.fields = [
					{ key: 'selected', label: 'Vybráno', sortable: false, class: 'text-center' },
					//{ key: 'id', label: 'Osobní číslo', sortable: true, class: 'text-center' },
					{ key: 'idPersonNavigationPersonalNumber', label: 'Osobní číslo', sortable: true, class: 'text-center' },
					{ key: 'idPersonNavigationLastname', label: 'Příjmení', sortable: true, class: 'text-center' },
					{ key: 'idPersonNavigationFirstname', label: 'Jméno', sortable: true, class: 'text-center' },
					{ key: 'idEnuTypeNavigationName', label: 'Druh pracovního poměru', sortable: true, class: 'text-center' },
					{ key: 'idJobTypeNavigationName', label: 'Profese', sortable: true, class: 'text-center' }
				];
			}
			else {
				this.fields = [

					{ key: 'idPersonNavigationPersonalNumber', label: 'Osobní číslo', sortable: true, class: 'text-center' },
					{ key: 'idPersonNavigationLastname', label: 'Příjmení', sortable: true, class: 'text-center' },
					{ key: 'idPersonNavigationFirstname', label: 'Jméno', sortable: true, class: 'text-center' },
					{ key: 'idEnuTypeNavigationName', label: 'Druh pracovního poměru', sortable: true, class: 'text-center' },
					{ key: 'idJobTypeNavigationName', label: 'Profese', sortable: true, class: 'text-center' }
				];
				if (this.isShowModal == false) {
					this.fields.push({ key: 'actions', label: 'Volby', sortable: false, class: 'text-center' });
				}
			}
		}

		//filtry
		setfilters(value: any) {
            if (value != null && value[0].lang == this.filters[0].lang) {
				this.filters = value;
			}
			else {
				this.filters = [
                    { key: 'idPersonNavigationPersonalNumber', label: 'Osobní číslo', selected: false, value: null, type: 'text', lang: this.$store.state.currentLanguage },
					{ key: 'idPersonNavigationLastname', label: 'Příjmení', isDate: true, selected: false, value: null, type: 'text' },
					{ key: 'idPersonNavigationFirstname', label: 'Jméno', selected: false, value: null, type: 'text' },
				];
			}
		}

		selectEmployment: any[] = [];
		selectRows(items: any) {
			this.selectEmployment = [];

			for (var i = 0; i < items.length; i++) {
				this.selectEmployment.push(items[i]);
			}

			this.selectEmployment = this.selectEmployment.sort((a, b) => ((a.idPersonNavigationFirstname) < (b.idPersonNavigationFirstname) ? -1 : 1))
				.sort((a, b) => (a.idPersonNavigationLastname < b.idPersonNavigationLastname ? -1 : 1));
		}

		validate() {
			return this.selectEmployment.length == 0;
		}

		sendSelected() {
			this.$emit('selectItem', this.selectEmployment);
		}

		prepareItems(items: any[]) {			
		}

		// VaP - toto zde musi byt, jinak nefunguje napojeni na tabulku
		loadFilters(value: any) { super.loadFilters(value); }
		createNewClick(elementId: any) { super.createNewClick(elementId); }
		detailClick(elementId: any) { super.detailClick(elementId); }
		deleteClick(elementId: any) { super.deleteClick(elementId); }

		fetchDataFromServer(): Promise<AxiosResponse<any>> {
			let employeeFilter: EmployeeFilter = new EmployeeFilter(this.$store.state.idTenant, false);
			return this.EmployeeService.getAllByFilter(employeeFilter);
		}

        //zatím nepotrebujeme
        fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
            return this.fetchDataFromServer();
        }

        refreshItems(items: any[], refreshData: any[]) {
            return items;
        }

		detailEmployee(EmployeeId: any) {
			if (this.isShowModal) {
				this.$emit('selectItem', this.tableData.filter(c => c.id == EmployeeId)[0]);
			}
			else if (this.isShowModalMulti) {
				if (this.selectEmployment.filter(c => c.id == EmployeeId).length == 0) {
					this.selectEmployment.push(this.tableData.filter(c => c.id == EmployeeId)[0]);
				}

				this.$emit('selectItem', this.selectEmployment);
				//	this.$emit('selectItem', this.Employees.filter(c => c.id == EmployeeId)[0]);
			}
			else if (this.hasRight) {
				this.$router.push({ name: "EmployeeCreate", params: { id: EmployeeId, type: "detail" } });
			}
		};


	};
